import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './reveal.module.scss';

export const LayoutsReveal = props => {
  const { children, className } = props;

  useEffect(() => {
    document.body.classList.add('reveal-page');

    return () => {
      document.body.classList.remove('reveal-page');
    };
  }, []);

  return (
    <div className={classnames(styles.layout, className)}>
      <main className="site-main">{children}</main>
    </div>
  );
};

LayoutsReveal.defaultProps = {
  showDetails: true
};

LayoutsReveal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  className: PropTypes.string
};

export default LayoutsReveal;
